





































import { Vue, Component, Watch } from 'vue-property-decorator';
import IRole from '@/store/models/IRole';
import IRolePermission from '@/store/models/IRolePermission';
import RoleApi from '../store/api/RoleApi';
import CompanyApi from '../store/api/CompanyApi';
import RolePermissionApi from '../store/api/RolePermissionApi';
import FormApi from '../store/api/FormApi';
import RoleSelector from '@/components/selectors/Role/RoleSelector.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICompany from '@/store/models/ICompany';
import IForms from '@/store/models/IForms';
import IAuthentication from '@/store/models/IAuthentication';
@Component({
    components: {
        RoleSelector,
        Snackbar
    }
})
export default class Role extends Vue {
    // RoleSelector
    RoleList : IRole[] = [];
    RolePermissionList : IRolePermission[] = [];
    RoleApi : RoleApi;
    CompanyApi : CompanyApi;
    FormApi : FormApi;
    RolePermissionApi : RolePermissionApi;
    selectedRole : IRole = {} as IRole;
    FormList : IForms [] = [];
    CompanyList : ICompany[] = [];
    idCompany : string = "";
    overlay : boolean = false;

    constructor() {
        super();
        this.RoleApi = new RoleApi();
        this.CompanyApi = new CompanyApi();
        this.RolePermissionApi = new RolePermissionApi();
        this.FormApi = new FormApi();
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
    }

    created() {
        this.getRoles();
        this.getCompanies();
        this.getForms();
    }

    async getRoles() {
        this.RoleList = await this.RoleApi.GetRoles(this.idCompany);
    }

    async getCompanies() {
        this.CompanyList = await this.CompanyApi.GetCompaniesById(this.idCompany);
    }

    async getForms() {
        this.FormList = await this.FormApi.GetForms();
    }

    async roleChanged(role: IRole) {
        if (role) {
            this.RolePermissionList = await this.RolePermissionApi.GetRolePermissions(role.id);
        }
    }

    deleteRole (item: IRole) {
        confirm('Are you sure you want to delete this Role?') && this.deleteRoleItem(item);
    }

    async deleteRoleItem(role: IRole) {
        this.overlay = true;
        let result: boolean = await this.RoleApi.DeleteRole(role.id);
        if (result) {
            await this.RolePermissionApi.DeleteRolePermissionsByRoleId(role.id);
            this.RolePermissionList = [];
            const index = this.RoleList.indexOf(role);
            this.RoleList.splice(index, 1);
            this.showMessageInfo(`The Role ${role.roleName} has been successfully deleted`);
        } else {
            const errors: string = this.RoleApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRole (role: IRole) {
        this.overlay = true;
        if (!role.id) {
            const id = await this.RoleApi.SaveRole(role);
            if (id) {
                role.id = id;
                this.FormList.forEach(async page => {
                    let pagePermission : IRolePermission = {} as IRolePermission;
                    pagePermission.idForm = page.id;
                    pagePermission.isAccesible = true;
                    pagePermission.isReadable = true;
                    pagePermission.isWritable = true;
                    pagePermission.isErasable = true;
                    pagePermission.idRole = id;
                    await this.RolePermissionApi.SaveRolePermission(pagePermission);
                    this.RolePermissionList = await this.RolePermissionApi.GetRolePermissions(role.id);
                });
                
                this.RoleList = [role].concat(this.RoleList);
                this.selectedRole = role;
                this.showMessageInfo(`The Role ${role.roleName} has been successfully saved`);
            } else {
                const errors: string = this.RoleApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.overlay = false;
    }

    async editRole (editedRole: IRole) {
        this.overlay = true;
        let result : boolean = await this.RoleApi.UpdateRole(editedRole);
        if (result) {
            this.showMessageInfo(`The Role ${editedRole.roleName} has been successfully edited`);
        } else {
            const errors: string = this.RoleApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRolePermission (rolePermission : IRolePermission) {
        this.overlay = true;
        if (this.selectedRole) {
            if (rolePermission) {
                await this.RolePermissionApi.SaveRolePermission(rolePermission);
            }
        }
        this.overlay = false;
    }

    async editRolePermission (editedRolePermission : IRolePermission) {
        this.overlay = true;
        let result : boolean = await this.RolePermissionApi.UpdateRolePermission(editedRolePermission);
        if (result) {
            this.showMessageInfo(`The Role Permission has been successfully edited`);
        } else {
            const errors: string = this.RolePermissionApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
